import { render, staticRenderFns } from "./details.pug?vue&type=template&id=48dfc4e0&lang=pug&external"
import script from "./details.js?vue&type=script&lang=js&external"
export * from "./details.js?vue&type=script&lang=js&external"
import style0 from "./details.scss?vue&type=style&index=0&lang=scss&external"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("C:\\Multiasistencia\\selfcare\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('48dfc4e0')) {
      api.createRecord('48dfc4e0', component.options)
    } else {
      api.reload('48dfc4e0', component.options)
    }
    module.hot.accept("./details.pug?vue&type=template&id=48dfc4e0&lang=pug&external", function () {
      api.rerender('48dfc4e0', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/modules/Claim/views/details/index.vue"
export default component.exports